module.exports = __webpack_public_path__ + "img/footer_service.7fe0bb0e.png";